"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquipmentSlot = void 0;
var EquipmentSlot;
(function (EquipmentSlot) {
    EquipmentSlot[EquipmentSlot["None"] = 0] = "None";
    EquipmentSlot[EquipmentSlot["Necklace"] = 1] = "Necklace";
    EquipmentSlot[EquipmentSlot["Ring1"] = 2] = "Ring1";
    EquipmentSlot[EquipmentSlot["Ring2"] = 3] = "Ring2";
    EquipmentSlot[EquipmentSlot["Armor"] = 4] = "Armor";
    EquipmentSlot[EquipmentSlot["MainHand"] = 5] = "MainHand";
    EquipmentSlot[EquipmentSlot["OffHand"] = 6] = "OffHand";
    EquipmentSlot[EquipmentSlot["Skin"] = 7] = "Skin";
    EquipmentSlot[EquipmentSlot["Head"] = 8] = "Head";
    EquipmentSlot[EquipmentSlot["Charm0"] = 9] = "Charm0";
})(EquipmentSlot = exports.EquipmentSlot || (exports.EquipmentSlot = {}));
